/**
 * NOTE: Keep in mind that feature flag names are camelCase.
 */
export enum JourneyFeatureFlags {
  LOGICS_ENGINE = 'journeyIsLogicsEngineEnabled',
  EXTERNAL_CATALOG_INTEGRATION = 'journeyExternalCatalogIntegration',
  GET_AG_PRICE_DETAILS = 'journeyGetagPriceDetails',
  DARK_MODE = 'journeyShowDarkModeButton',
  ALTERNATIVE_ADDRESS_FINDER = 'journeyAlternativeAddressFinder'
}
